// extracted by mini-css-extract-plugin
module.exports = {"iframe":"_2787e5dfdf--iframe--1gVc1","loading":"_2787e5dfdf--loading--N-xVU","container":"_2787e5dfdf--container--2x3T3","loader-wrapper":"_2787e5dfdf--loader-wrapper--2ddAk"};